import { Pipe, PipeTransform } from '@angular/core';
import { Util } from '../utils/util';

@Pipe({name: 'cpfCnpjMask'})
export class CpfCnpjPipe implements PipeTransform {

	transform(value: string) {
		if (value) {
			return Util.formatCpfCnpj(value.toString());
		}
		return value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/cpf-cnpj.pipe.ts